<template>
    <div class='header'>
        Toronto Fire Active Incidents
    </div>
</template>

<style scoped>
    .header {
        background-color: #dea061;
        color: #a11128;
        font-family: sans-serif;
        font-size: 3em;
    }
</style>